module.exports = __webpack_public_path__ + "img/colorful.05a64eaa.png";